import type { DoorViewSide } from '../surfaces/doorViewSide';
import type { DoorConfiguration } from '../types/doorConfiguration';

export type ColourSurface = 'frame' | 'slab' | 'cill' | 'threshold';

export function colourIdForViewSide(
  configuration: DoorConfiguration,
  surface: ColourSurface,
  viewSide: DoorViewSide
): string {
  if (viewSide === 'internal') {
    if (surface === 'frame') return configuration.internalFrameColourId;
    if (surface === 'cill') return configuration.internalCillColourId;
    if (surface === 'threshold') return configuration.internalThresholdColourId;
    return configuration.slab.internalColourId;
  }
  if (surface === 'frame') return configuration.frameColourId;
  if (surface === 'cill') return configuration.cillColourId;
  if (surface === 'threshold') return configuration.thresholdColourId;
  return configuration.slab.colourId;
}

export function applyColourForViewSide(
  configuration: DoorConfiguration,
  surface: ColourSurface,
  viewSide: DoorViewSide,
  colourId: string
): DoorConfiguration {
  if (viewSide === 'internal') {
    if (surface === 'frame') return { ...configuration, internalFrameColourId: colourId };
    if (surface === 'cill') return { ...configuration, internalCillColourId: colourId };
    if (surface === 'threshold') return { ...configuration, internalThresholdColourId: colourId };
    return { ...configuration, slab: { ...configuration.slab, internalColourId: colourId } };
  }
  if (surface === 'frame') return { ...configuration, frameColourId: colourId };
  if (surface === 'cill') return { ...configuration, cillColourId: colourId };
  if (surface === 'threshold') return { ...configuration, thresholdColourId: colourId };
  return { ...configuration, slab: { ...configuration.slab, colourId } };
}
